module.exports = __webpack_public_path__ + "img/925f6734c65b5b6fd1677f7cc712d3aa.cddd5ce3.jpg";